/**
 * Call-to-action section with full-width turquoise background.
 *
 * Displays a headline, subheading, and two action buttons (Browse Plans
 * and Login). Buttons stack vertically on mobile and sit side-by-side
 * on larger viewports. All text is sourced from the `landing` i18n namespace.
 *
 * @module landing/sections/CtaSection
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer } from '../../../shared/src/responsive/ResponsiveContainer';
import { SectionHeading } from '../components/SectionHeading';

/**
 * CTA section with Browse Plans and Login buttons.
 */
export function CtaSection(): React.JSX.Element {
  const { t } = useTranslation('landing');

  return (
    <ResponsiveContainer>
      <SectionHeading
        title={t('cta.heading')}
        subtitle={t('cta.subheading')}
        light
      />
      <div className="landing-cta__buttons">
        <a
          href="/public-discovery/plans"
          className="ipa-btn landing-cta__btn--inverted"
        >
          {t('cta.browsePlans')}
        </a>
        <a
          href="/login/"
          className="ipa-btn landing-cta__btn--outline"
        >
          {t('cta.login')}
        </a>
      </div>
    </ResponsiveContainer>
  );
}
